import { useMutation, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useUpdatePaymentGateway = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/payment-gateways`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries(["integrations"]);
    },
  });
};
